"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dxcScrollMenu = _interopRequireDefault(require("dxc-scroll-menu"));

var _Theme = _interopRequireDefault(require("../../assets/Theme4.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _panoMarquee = _interopRequireDefault(require("pano-marquee"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _onResize = _interopRequireDefault(require("../onResize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme["default"]);

var MenuContent = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuContent, _React$PureComponent);

  function MenuContent(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "onClick", function (id) {
      var onClick = _this.props.onClick;
      onClick && onClick(id);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref, index) {
      var id = _ref.id,
          name = _ref.name;
      var _this$props = _this.props,
          selected = _this$props.selected,
          size = _this$props.size,
          disableTip = _this$props.disableTip,
          _this$props$ui = _this$props.ui,
          ui = _this$props$ui === void 0 ? {} : _this$props$ui,
          theme = _this$props.theme;
      var param = {};

      if (!disableTip) {
        param["data-tip"] = name;
      }

      var color = selected !== id ? ui.fontColor : ui.fontAvtiveColor;
      var background = selected !== id ? ui.bgColor : ui.btnActiveColor;
      var style = {
        background: theme === 3 ? background : undefined,
        borderBottom: theme === 103 && selected === id ? "2px solid " + background : undefined
      };
      var data = _this.props.data;

      if (index === 0) {
        style.marginLeft = 0;
      }

      if (index === data.length - 1) {
        style.marginRight = 0;
      }

      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], _extends({
        onClick: _this.onClick.bind(_assertThisInitialized(_this), id),
        vertical: "center",
        key: id,
        className: cx("TextMenuItemTheme4", {
          selected: selected === id
        })
      }, param, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement(_panoMarquee["default"] // disableColor='#C7C7C7'
      , {
        color: color,
        disableColor: color,
        maxWidth: size.MarqueeMaxWidth,
        disable: selected !== id,
        fontSize: size.MarqueeFontSize,
        text: name
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowRight", function (disable, onClick) {
      if (disable) return null;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowRight")
      }, /*#__PURE__*/_react["default"].createElement("div", null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowLeft", function (disable, onClick) {
      if (disable) return null;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowLeft")
      }, /*#__PURE__*/_react["default"].createElement("div", null));
    });

    var _ui = props.ui,
        _size = props.size;
    _this.state = {
      itemData: {
        ui: _ui,
        size: _size
      }
    };
    return _this;
  }

  var _proto = MenuContent.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
        ui = _this$props2.ui,
        size = _this$props2.size;
    var prevUi = prevProps.ui,
        prevSize = prevProps.size;

    if (ui !== prevUi || size !== prevSize) {
      this.setState({
        itemData: {
          ui: ui,
          size: size
        }
      });
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        selected = _this$props3.selected,
        data = _this$props3.data,
        ui = _this$props3.ui;
    var itemData = this.state.itemData;
    return /*#__PURE__*/_react["default"].createElement(_dxcScrollMenu["default"], {
      itemData: itemData,
      horizontal: "left",
      arrowRight: this.renderArrowRight,
      arrowLeft: this.renderArrowLeft,
      data: data,
      selected: selected,
      renderItem: this.renderItem
    });
  };

  return MenuContent;
}(_react["default"].PureComponent);

var _default = (0, _onResize["default"])({
  "default": {
    MarqueeMaxWidth: 100,
    MarqueeFontSize: 14
  },
  1024: {
    MarqueeMaxWidth: 75,
    MarqueeFontSize: 12
  }
})(MenuContent);

exports["default"] = _default;
module.exports = exports.default;